import { useEffect, useState } from 'react';

export const useHandleReactHydration = () => {
  const [isNotFirstRender, setIsNotFirstRender] = useState(false);

  useEffect(() => setIsNotFirstRender(true), []);
  return { isNotFirstRender };
};
